






































import { PartyProductModel, ApplicationUserModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import RequestForQuotationDialog from '@/libs/account/components/RequestForQuotationDialog.vue';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { CrudGetter } from '@/libs/core/crud/crud-getter';

@Component({
    components: {
        RequestForQuotationDialog
    }
})
export default class ClientNOIFCard extends Vue {

    @Prop() partyProduct!: PartyProductModel;
    @Prop() clientId!: string;
    @Ref() dialogRequest!: RequestForQuotationDialog;
    @Prop({ default: false }) accountSection!: boolean;
    
    newId: string | null = Guid.EmptyGuid();

    get user(): ApplicationUserModel {
        return applicationUserStore.useGetter(CrudGetter.Detail);
    }

    openPartyProduct() {
        this.dialogRequest.open();
    }

}

